export const _calculateFileSize = (size) => {
    if (!size) {
        return "0 bytes"
    }
    
    if (size < Math.pow(10, 3)) // bytes
        return `${size} bytes`;
    else if (size >= Math.pow(10, 3)) {
        return `${(size / Math.pow(10, 3)).toFixed(1)} kb`;
    }
    else if (size >= Math.pow(10, 6)) {
        return `${(size / Math.pow(10, 6)).toFixed(1)} MB`;
    }
    else if (size >= Math.pow(10, 9)) {
        return `${(size / Math.pow(10, 9)).toFixed(1)} GB`;
    }
    else if (size >= Math.pow(10, 12)) {
        return `${(size / Math.pow(10, 12)).toFixed(1)} TB`;
    }
}